module.exports = __webpack_public_path__ + "media/Ari Lasso feat Bunga Citra Lestari - Aku Dan Dirimu.c5388e89.mp3";